import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ClientDetail } from '../../../types/clients.types';
import { LENDER_STATUS } from '../../../constants/clients.constants';

interface ClientCardProps {
  client: ClientDetail;
  isAdmin: boolean;
  onDeleteClient: (clientId: string) => void;
}

export const ClientCard: React.FC<ClientCardProps> = ({
  client,
  isAdmin,
  onDeleteClient,
}) => {
  const navigate = useNavigate();

  const activeLenders = client.lenders.filter((l) => l.status === LENDER_STATUS.ACTIVE);
  const totalLenders = activeLenders.length;

  return (
    <div
      onClick={() => navigate(`/clients/${client.id}`)}
      className="bg-white rounded-2xl shadow-sm border border-slate-200/80 overflow-hidden transition-shadow hover:shadow-md cursor-pointer"
    >
      <div className="flex items-center justify-between px-5 py-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-10 h-10 rounded-xl bg-blue-50 border border-blue-100 flex items-center justify-center flex-shrink-0">
            <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <div className="min-w-0">
            <h3 className="text-sm font-semibold text-slate-900 truncate">{client.name}</h3>
            <p className="text-xs text-slate-500">
              {totalLenders} lender{totalLenders !== 1 ? 's' : ''}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          {isAdmin && (
            <button
              onClick={(e) => { e.stopPropagation(); onDeleteClient(client.id); }}
              className="p-1.5 rounded-lg text-slate-400 hover:text-red-500 hover:bg-red-50 transition-colors"
              title="Delete client"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          )}
          <svg className="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </div>
  );
};
